import { CURRENCY_SYMBOLS } from '@/types';

/**
 * Format money with currency symbol
 */
export function formatMoney(amount: number, currency: string): string {
  const symbol = CURRENCY_SYMBOLS[currency] || '$';
  return `${symbol}${amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/**
 * Combine class names (useful for Tailwind)
 */
export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}

/**
 * Get category label in specific language
 */
export function getCategoryLabel(
  categoryId: string,
  language: 'en' | 'fr',
  categories: Record<string, { en: string; fr: string }>
): string {
  return categories[categoryId]?.[language] || categoryId;
}

/**
 * Format date to readable string
 */
export function formatDate(date: Date): string {
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

/**
 * Calculate savings
 */
export function calculateSavings(
  salary: number,
  gains: number,
  expenses: number
): number {
  return salary + gains - expenses;
}